/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Link_StatusInputs */

const en_orders_link_status = /** @type {(inputs: Orders_Link_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Status`)
};

const es_orders_link_status = /** @type {(inputs: Orders_Link_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado del link`)
};

/**
* | output |
* | --- |
* | "Link Status" |
*
* @param {Orders_Link_StatusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_link_status = /** @type {((inputs?: Orders_Link_StatusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Link_StatusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_link_status(inputs)
	return es_orders_link_status(inputs)
});